import { toast } from "react-toastify";
import React from "react";
import axios from "axios";
export const API_URL = process.env.REACT_APP_API_URL;
export const STRIPE_CLIENT_ID = process.env.REACT_APP_STRIPE;

export const PERSIST_GYMS = "gyms";
export const PERSIST_GYMS_SEARCH_QUERY = "searchQuery";
export const PERSIST_GYMS_CURRENT_PAGE = "currentGymPage";
export const PERSIST_GYMS_COUNT_PER_PAGE = "currentGymCountPerPage";
export const GYM_TAG_UNIQUE_ID = "Tag";
export const ADJUST_TRACKING_KEY = "ADJUST_TRACKING";
export const ADJUST_TRACKING_URL = "ADJUST_TRACKING_URL";
export const ADJUST_TRACKING_PROMO_CODE = "ADJUST_TRACKING_PROMO_CODE";
export const VIRTUAL_TRAINING_NAVIGATION_KEY = "virtual_training_navigation";

export const LOG_OUT = () => {
  const access_token = localStorage.getItem("access_token");
  axios
    .get(`${API_URL}/admin/logout`, {
      headers: {
        "x-access-token": access_token
      }
    })
    .then(res => {
      clearLocalStorage();
    })
    .catch(err => {
      if (err.response) {
        err.response.status === 401 ? clearLocalStorage() : ERROR_HANDLE(err);
      } else {
        toast.error("Network Error", { autoClose: 2500 });
      }
    });
};

export const clearLocalStorage = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("email");
  localStorage.removeItem(PERSIST_GYMS);
  localStorage.removeItem(PERSIST_GYMS_SEARCH_QUERY);
  localStorage.removeItem(PERSIST_GYMS_CURRENT_PAGE);
  window.location.assign("/");
};

export const ERROR_HANDLE = err => {
  console.log(err);
  console.log(JSON.stringify(err));
  if (err.response) {
    const response = err.response;
    switch (response.status) {
      case 400:
        if (response.data.stripe_response) {
          toast.error(response.data.stripe_response, { autoClose: 2500 });
        } else {
          toast.error(response.data.error, { autoClose: 2500 });
        }
        break;
      case 401:
        toast.error(response.data.error, { autoClose: 2500 });
        LOG_OUT();
        break;
      case 404:
        toast.error(response.data.error, { autoClose: 2500 });
        break;
      default:
        toast.error("Opps! Server Error", { autoClose: 2500 });
    }
  } else {
    toast.error("Network Error", { autoClose: 2500 });
  }
};

export const DOWNLOAD = (data, fileName) => {
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";
  const blob = new Blob([data], { type: "octet/stream" });
  a.href = window.URL.createObjectURL(blob);
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(a.href);
};

export const urlify = text => {
  if (text) {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    let modifiedText = text.replace(urlRegex, function (url) {
      return '<a href="' + url + '">' + url + "</a>";
    });

    return modifiedText;
  }
  // or alternatively
  // return text.replace(urlRegex, '<a href="$1">$1</a>')
};
